import * as React from 'react';
import { Component } from 'react';
import styles from '../styles/wizards/EditSpecificationsResponsibleUserWizard.scss';
import autobind from 'autobind-decorator';
import {
  __,
  mapStateToProps,
  setTableParams,
  validateForm,
} from '../core/utils';
import { withRouter } from 'react-router';
import { setNotification } from '../redux/actions/general/notification';
import SpaceAllocationIcon from '../assets/images/space-allocation-24x24.svg';
import EditSpecificationsAreaForm from '../forms/edit_specifications_area_wizard/EditSpecificationsAreaForm';
import {
  addAreaToSpecifications,
  readSpecificationSetItems,
} from '../redux/actions/table/specification_sets';
import { hideAlertbox, showAlertbox } from '../redux/actions/general/alertbox';
import { getBOQArea } from '../redux/actions/table/working_set_boq';

@withRouter
@mapStateToProps((state) => ({
  selected_specification_ids:
    state.table.specification_sets.selected_specification_ids,
  language_id:
    state.table.specification_sets.flyout?.main_language ||
    state.auth.language_id,
}))
class EditSpecificationsAreaWizard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      space_allocation: {},
    };
  }

  componentDidMount() {
    getBOQArea(this.props.match.params.stage).then(({ response }) => {
      this.setState({ space_allocation: response.data });
    });
  }

  @autobind
  _handleSubmit(formData) {
    validateForm(
      addAreaToSpecifications(
        this.props.selected_specification_ids,
        formData.area,
        this.props.match.params.stage
      ).then(() => {
        setNotification(
          __(
            'wizard.specification-set-items.message.area-added-to-selected-specifications'
          )
        );

        this.props.onClose();

        readSpecificationSetItems(this.props.match.params.specification_set);

        setTableParams('specification_sets', {
          selected_rows: [],
          selected_specification_ids: [],
        });
      })
    );
  }

  render() {
    return (
      <>
        <div className={styles.header}>
          <div className={styles.left}>
            <span>
              {__(
                'wizard.specification-set-items.title.add-area-to-selected-specifications'
              )}
            </span>
            <span>
              {__(
                'wizard.specification-set-items.subtitle.add-area-to-selected-specifications'
              )}
            </span>
          </div>
          <div className={styles.right}>
            <SpaceAllocationIcon />
          </div>
        </div>
        <div className={styles.body}>
          <EditSpecificationsAreaForm
            onSubmit={this._handleSubmit}
            languageId={this.props.language_id}
            spaceAllocationData={this.state.space_allocation}
          />
        </div>
      </>
    );
  }
}

export default EditSpecificationsAreaWizard;
